import React, { useState } from 'react';
import './Dropdown.css';

const Dropdown = ({ 
  label, 
  options, 
  value, 
  onChange, 
  placeholder = "Seleccionar...",
  className = ""
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  const selectedOption = options.find(opt => opt.value === value);

  return (
    <div className={`dropdown-container ${className}`}>
      {label && <label className="dropdown-label">{label}</label>}
      <div className="dropdown-wrapper">
        <button 
          className="dropdown-button"
          onClick={() => setIsOpen(!isOpen)}
          type="button"
        >
          <span className="dropdown-text">
            {selectedOption ? selectedOption.label : placeholder}
          </span>
          <span className={`dropdown-arrow ${isOpen ? 'open' : ''}`}>
            ▼
          </span>
        </button>
        
        {isOpen && (
          <div className="dropdown-menu">
            {options.map((option) => (
              <button
                key={option.value}
                className={`dropdown-option ${value === option.value ? 'selected' : ''}`}
                onClick={() => handleSelect(option)}
                type="button"
              >
                {option.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Dropdown;
